import UBanner from './UBanner'

export default UBanner;
